// Convert between "GWAII HAANAS" and "gwaii-haanas"
export const organizationURLStyle = organization =>
  organization.toLowerCase().replace(" ", "-");
export const organizationAPIStyle = organization =>
  organization.toUpperCase().replace("-", " ");
